import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=49f10ff4"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports